export type {FontAwesomeV6IconProps} from './FontAwesomeV6Icon';
export {default as default} from './FontAwesomeV6Icon';
